import React from 'react';
import { SearchAd } from '@gumtree/shared/src/model/search-ads-model';
import { PageLayout } from '@gumtree/shared/src/types/srp';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

import { css } from '@emotion/react';
import {
    fontSizes,
    gutterSizes,
    colors,
    fontWeights,
    lineHeights,
} from '@gumtree/ui-library/src/base/theme';
import ResultsList from '@gumtree/ui-library/src/results-list';
import { formatNumber } from '@gumtree/ui-library/src/utils/currency-service';
import { UpdateRequestQuoteFormData } from '@gumtree/shared/src/types/request-quote-form';

const NearbyAdsList = ({
    nearbyAds,
    pageLayout,
    totalNearbyAdsNumFound,
    newUi,
    updateRequestQuoteFormData,
    requestId,
    showPostDate = true,
}: {
    nearbyAds: SearchAd[];
    pageLayout: PageLayout;
    totalNearbyAdsNumFound: number;
    newUi?: boolean;
    updateRequestQuoteFormData?: UpdateRequestQuoteFormData;
    requestId?: string;
    showPostDate?: boolean;
}) => {
    return nearbyAds.length ? (
        <div
            css={css`
                position: relative;
                margin-top: ${gutterSizes.xlarge};
                padding-top: ${gutterSizes.xxlarge};

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: ${pageLayout === PageLayout.TwoColumns ? gutterSizes.large : 0};
                    right: ${pageLayout === PageLayout.TwoColumns ? gutterSizes.large : 0};
                    border-top: 1px solid ${colors.newBorder};
                    height: 0;
                }
            `}
            {...qaAttribute('nearby-results')}
        >
            <h2
                css={css`
                    font-size: ${fontSizes.xlarge};
                    margin: 0 ${pageLayout === PageLayout.TwoColumns ? gutterSizes.large : 0} ${gutterSizes.base};
                `}
                {...qaAttribute('nearby-results-title')}
            >
                Results from outside your search
            </h2>
            <h3
                css={css`
                    font-weight: ${fontWeights.normal};
                    font-size: ${fontSizes.base};
                    line-height: ${lineHeights.base};
                    color: ${colors.newDarkGrey};
                    margin-top: 0;
                    margin-right: ${pageLayout === PageLayout.TwoColumns ? gutterSizes.large : 0};
                    margin-left: ${pageLayout === PageLayout.TwoColumns ? gutterSizes.large : 0};
                    margin-bottom: ${gutterSizes.xxlarge};
                `}
            >
                Here are {formatNumber(totalNearbyAdsNumFound)} additional result
                {totalNearbyAdsNumFound > 1 ? 's' : ''} in your extended area
            </h3>
            <ResultsList
                {...qaAttribute('nearby-results-list')}
                ads={nearbyAds}
                pageLayout={pageLayout}
                newUi={newUi}
                updateRequestQuoteFormData={updateRequestQuoteFormData}
                requestId={requestId}
                showPostDate={showPostDate}
            />
        </div>
    ) : (
        <></>
    );
};

export default NearbyAdsList;
